"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstImageSrc = void 0;
var getFirstImageSrc = function getFirstImageSrc(str) {
  var regex = /^[\s\S]*<img src="([^"]+)"[\s\S]*$/i;
  return regex.test(str) ? str.replace(regex, '$1') : '';
};
exports.getFirstImageSrc = getFirstImageSrc;